export default "__VITE_ASSET__a4ac20f5__"